import { createContext, useCallback, useContext, useRef, useState } from "react";

const PlayerContext = createContext(null);

export const usePlayer = () => useContext(PlayerContext);

export function PlayerProvider({ children }) {
    const audioRef = useRef(null);
    const [current, setCurrent] = useState(null);
    const [playing, setPlaying] = useState(false);

    const playEpisode = useCallback(
        (ep) => {
            if (current?.id === ep.id) {
                const a = audioRef.current;
                if (a) {
                    if (a.paused) a.play();
                    else a.pause();
                }
                return;
            }
            setCurrent(ep);
            setPlaying(true);
        },
        [current]
    );

    const close = useCallback(() => {
        const a = audioRef.current;
        if (a) a.pause();
        setCurrent(null);
        setPlaying(false);
    }, []);

    return (
        <PlayerContext.Provider
            value={{ audioRef, current, playing, setPlaying, playEpisode, close }}
        >
            {children}
        </PlayerContext.Provider>
    );
}
